/**
 * Semantic alias representing an InVivo product variant ID
 * @FIXME should probably be common
 */
export type VariantId = string

/**
 * Semantic alias representing an InVivo partner/cooperative/seller ID
 * @FIXME should probably be common
 */
export type PartnerId = string

/**
 * Semantic alias representing an InVivo warehouse ID
 */
export type WarehouseId = string

/**
 * Semantic alias representing an InVivo warehouse name
 */
export type WarehouseName = string

/**
 * Semantic alias representing a value that we failed to gather
 */
export type NotDisclosed = null

/**
 * Semantic alias representing the unit of a quantity that we did successfuly gather
 */
export type DisclosedUnit = string

/**
 * Represents the unit of a quantity, possibly not disclosed
 */
export type Unit = DisclosedUnit | NotDisclosed

/**
 * Semantic alias representing a stock quantity that we did successfuly gather
 */
export type DisclosedStockQuantity = number

/**
 * Represents a stock quantity, possibly not disclosed
 */
export type StockQuantity = DisclosedStockQuantity | NotDisclosed

export function isDisclosed<T>(maybeDisclosed: T | NotDisclosed): maybeDisclosed is T {
  return maybeDisclosed !== null
}

/**
 * Represents variant data required to comply with stocks display consistency constraints
 */
export type StockVariant = {
  /**
   * Allows matching
   */
  id: VariantId
  /**
   * Allows to display (consistent) variant names
   */
  name: string
  /**
   * Allows to enable/disable navigation features only if relevant (i.e. only if offers exist for this variant)
   */
  offers: unknown[]
}
